import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChildren,
  input,
  InputSignal,
  Signal,
  ViewEncapsulation
} from '@angular/core';
import { NgTemplateOutlet, SlicePipe } from '@angular/common';
import { LinearListItemTemplateDirective } from './linear-list-item-template.directive';

export type LinearListType = 'flex' | 'grid' | 'flex_column';

@Component({
  selector: 'td-wb-linear-list',
  templateUrl: 'linear-list.component.html',
  styleUrls: ['linear-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, SlicePipe],
  host: {
    'role': 'table',
    '[class.td-wb-linear-list__flex]': 'listType() === "flex"',
    '[class.td-wb-linear-list__grid]': 'listType() === "grid"',
    '[class.td-wb-linear-list__flex--column]': 'listType() === "flex_column"'
  }
})
export class LinearListComponent {

  readonly listType: InputSignal<LinearListType> = input<LinearListType>('flex');
  readonly noOfSummaryColumns: InputSignal<number> = input<number>(0);

  readonly rows: Signal<ReadonlyArray<LinearListItemTemplateDirective>> = contentChildren(LinearListItemTemplateDirective);

  readonly contentRows: Signal<ReadonlyArray<LinearListItemTemplateDirective>> = computed((): ReadonlyArray<LinearListItemTemplateDirective> => {
    const summaryCount: number = this.noOfSummaryColumns();
    const allRows: ReadonlyArray<LinearListItemTemplateDirective> = this.rows();

    if (summaryCount > 0) {
      return allRows.filter((_: LinearListItemTemplateDirective, index: number): boolean => index >= summaryCount);
    }
    return [...allRows];
  });

  readonly isFlexColumn: Signal<boolean> = computed((): boolean => {
    return this.listType() === 'flex_column' && this.noOfSummaryColumns() > 0;
  });
}
